import { useContext } from "react";
import Word from "./Word";
import StoryContext from "../context/StoryContext";
import styles from "./WordList.module.scss";
import Space from "./Space";
import { Link } from "react-router-dom";

function isPunctuationMark(string) {
  const re = /^[,.!?;:]+$/;
  return re.test(string);
}

function WordList(props) {
  let words = useContext(StoryContext);
  let wordObjs = [];
  words.forEach((word_item, index, words) => {
    let wordObj = (
      <Link to={`/vote/${word_item._id}`} key={word_item._id}>
        <Word
          id={word_item._id}
          word={word_item.winner}
          confidence={word_item.confidence}
          key={word_item._id}
        />
      </Link>
    );
    wordObjs.push(wordObj);
    if (
      index + 1 < words.length &&
      !isPunctuationMark(words[index + 1].winner)
    ) {
      wordObjs.push(<Space key={-wordObjs.length - 1} />);
    }
  });

  return (
    <div className={styles.wordContainer}>
      {wordObjs}
      <Space />
      <div className={styles.currentVotingWord}>
        <Link to="/vote">
          <Word
            id={-1}
            word="[Voting in progress]"
            confidence={0}
            key={-1}
          />
        </Link>
      </div>
    </div>
  );
}

export default WordList;
